<template>
    <a-menu class="towerList"
        mode="inline" :inlineIndent="12"
    >
        <a-input v-model="substr" />
        <RecycleScroller class="scroller"
            :items="filteredTowers" :item-size="32"
            key-field="name" ref="scroller"
        >
            <li slot-scope="{ item }" :key="item.name"
                :class="{ 
                    'ant-menu-item-selected': $route.params.id == item.name 
                }"
                class="ant-menu-item" @click="selectTower(item.name)"
            >{{ item.title }}</li>
        </RecycleScroller>
    </a-menu>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
    props: [ "towers" ],
    data: () => ({
        substr: "",
    }),
    computed: {
        filteredTowers() {
            if (this.substr == "") return this.towers;
            return this.towers.filter((e) => e.title.indexOf(this.substr) !== -1);
        }
    },
    methods: {
        selectTower(name) {
            this.$emit("selectTower", name);
        },
        showIndex(index) {
            this.$nextTick(() => {
                const scroller = this.$refs.scroller;
                if (scroller.$_startIndex > index || scroller.$_endIndex < index + 10) {
                    scroller.scrollToItem(Math.max(index - 3));
                }
            })
        },
    },
    components: {
        RecycleScroller
    }
}
</script>

<style lang="less">
.towerList {
    height: 100%;
    border-right: 1px;
    overflow-y: auto;
    .scroller {
        margin-top: 3px;
        height: calc(100% - 35px);
    }
    .ant-menu-item {
        height: 24px;
        line-height: 24px;
    }
}
</style>